<script>
	import { isPortraitScreen, logoDone, pageOffset } from '../js/model/stores';
	import { freezeElement, animateElement } from '../js/utils/animate';

	let _subline;
	let done = false;
	let portrait;

	export let text;

	let animation = (value) => {
		animateElement(value, _subline, (currentPageOffset) => {
			if(done || !$logoDone) {
				return;
			}

			done = true;
			setTimeout(() => {
				_subline.style.opacity = 1;
			}, 400);
		});

		freezeElement(value, _subline, (currentPageOffset) => {
			if(!done || !$logoDone) {
				return;
			}
			done = false;
			_subline.style.opacity = 0;
		});
	};

	let prepareScene = () => {
		if (!_subline) {
			requestAnimationFrame(prepareScene);
			return;
		}

		pageOffset.subscribe(animation);
		logoDone.subscribe(animation);
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareScene();
</script>

<style>
    h1 {
        position: absolute;
        top: 20em;
        left: 50%;
        width: 100vw;
        transform: translateX(-50%);
        margin: 0;
        z-index: 5;

        opacity: 0;
		transition: opacity .5s;
    }

    h1.portrait {
    	top: 20em;
        width: 60vw;
		font-size: calc(var(--font-h1-size) * 0.8);
    }

    span {
        text-transform: uppercase;
    }

</style>

<h1 class:portrait bind:this={_subline}>
	{#if text}
		{@html text}
	{:else}
		<strong>Gemeinsam</strong> für eine europäische <span><br/><strong>Kulturhauptstadt</strong> Chemnitz 2025</span>.
	{/if}
</h1>
